import * as React from "react"
import { Outlet, Link } from "react-router-dom"
import { TrendingUp, FileUp } from "lucide-react"
import { ThemeToggle } from "@/shared/ui/molecules/ThemeToggle"
import { UserMenu } from "@/shared/ui/molecules/UserMenu"
import { Button } from "@/shared/ui/atoms/Button"
import { NotionImportModal } from "@/features/transactions/components/molecules/NotionImportModal"

export function AppShell() {
  const [isImportModalOpen, setIsImportModalOpen] = React.useState(false)
  const isNotionImportEnabled = import.meta.env.VITE_FEATURE_NOTION_IMPORT_ENABLED !== "false"

  return (
    <div className="flex min-h-[100dvh] w-full flex-col bg-background text-foreground antialiased pb-safe">
      {/* Top Navbar — Sticky & Clean */}
      <header className="sticky top-0 z-30 flex flex-col w-full border-b border-border/80 bg-background/80 pt-safe backdrop-blur-md transition-colors">
        <div className="flex h-16 w-full items-center justify-between px-4 sm:px-6 lg:px-8">
          {/* Brand / Logo */}
          <Link
            to="/dashboard"
            className="flex items-center gap-2.5 group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-lg px-1 py-0.5 transition-opacity hover:opacity-90"
            aria-label="Cartera Dashboard"
          >
            <div className="flex size-8 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-xs transition-transform group-hover:scale-105">
              <TrendingUp className="size-4.5 stroke-[2.2]" />
            </div>
            <span className="font-display text-base sm:text-lg font-bold tracking-tight text-foreground">
              Cartera
            </span>
          </Link>

          {/* Global Controls & User Info */}
          <div className="flex items-center gap-2 sm:gap-3">
            {isNotionImportEnabled && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => setIsImportModalOpen(true)}
                className="gap-1.5 text-xs font-medium cursor-pointer shadow-2xs"
              >
                <FileUp className="size-3.5 text-primary" />
                <span className="hidden sm:inline">Importar Notion</span>
              </Button>
            )}
            <ThemeToggle />
            <UserMenu />
          </div>
        </div>
      </header>

      {/* Notion Import Modal */}
      {isNotionImportEnabled && (
        <NotionImportModal
          open={isImportModalOpen}
          onOpenChange={setIsImportModalOpen}
        />
      )}

      {/* Main Single-Page Content Area */}
      <main className="flex-1 w-full overflow-x-hidden">
        <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 sm:py-8 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
